module.exports = __webpack_public_path__ + "img/u56.f76b82f2.svg";